import axios from "axios";
import { API_GET_PRODUCT_CATEGORIES_BY_BAR_DATA, API_GET_PRODUCT_CATEGORIES_DATA, API_INSERT_PRODUCT_CATEGORY_DATA, API_TOGGLE_PRODUCT_CATEGORY_DATA, API_UPDATE_PRODUCT_CATEGORY_DATA } from ".";

export const getProductCategoriesList = async (func, config) => {
    return axios.get(API_GET_PRODUCT_CATEGORIES_DATA, config).then(res => func(res.data.data));
}

export const getProductCategoriesByBarList = async (func, config, id) => {
    return axios.get(API_GET_PRODUCT_CATEGORIES_BY_BAR_DATA+`?product_category_bar_id=${id}`, config).then(res => func(res.data.data));
}

export const insertProductCategoryData = async (data, config) => {
    return axios.post(API_INSERT_PRODUCT_CATEGORY_DATA, data, config).then((res) => res.data);
};

export const updateProductCategoryData = async (data, config) => {
    return axios.post(API_UPDATE_PRODUCT_CATEGORY_DATA, data, config).then((res) => res.data);
};

export const toggleProductCategoryData = async (data, config, cb) => {
    return axios.put(API_TOGGLE_PRODUCT_CATEGORY_DATA, data, config).then((res) => {
        if (res.data.status === "success") {
            cb();
        };
    });
};